import React, { Component } from 'react'
import { toast } from 'react-toastify'
import { Container, Button, Form, Header } from 'semantic-ui-react'
import workServer from '../../../../shared/apis/work-server.api.js'
import Authentication from '../../shared/services/authentication'
import { setOutlets } from '../../../../shared/models/outlets.model'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'

class LoginPage extends Component {
  state = {
    username: null,
    password: null,
    date: null,
    shift: null,
    updating: false,
    outlet: null,
    outlets: [],
    user: null
  }

  options = [
    { value: 'S', text: 'Sáng' },
    { value: 'C', text: 'Chiều' },
    { value: 'T', text: 'Tối' }
  ]

  updateField = field => (e, { value }) => {
    this.setState({
      [field]: value
    })
  }

  // Bước 1: xác thực tài khoản. Danh sách cơ sở do server trả về sau khi đăng nhập,
  // vì các route lấy cơ sở của 4handy-work yêu cầu đăng nhập.
  authenticate = () => {
    this.setState({
      updating: true
    })
    workServer
      .authenticate({
        username: this.state.username,
        password: this.state.password
      })
      .then(({ user, outlets }) => {
        setOutlets(outlets)
        this.setState({
          user,
          outlet: null,
          outlets: _.map(outlets, outlet => ({
            value: outlet.code,
            text: `${outlet.code} - ${outlet.name}`
          })),
          updating: false
        })
      })
      .catch(err => {
        toast.error(err.message)
        this.setState({ updating: false })
      })
  }

  // Bước 2: chọn cơ sở để server tạo/lấy ca trực tương ứng.
  login = () => {
    if (!this.state.outlet) {
      toast.error('Chưa chọn cơ sở')
      return
    }
    this.setState({
      updating: true
    })
    workServer
      .login({
        username: this.state.username,
        password: this.state.password,
        outlet: this.state.outlet
      })
      .then(({ user, currentShift }) => {
        Authentication.setUser(user)
        Authentication.setCurrentShift(currentShift)
        this.props.updateUser(user)
        this.props.updateCurrentShift(currentShift)
        toast.success('Đăng nhập thành công')
        this.props.history.push('/')
      })
      .catch(err => {
        toast.error(err.message)
        this.setState({ updating: false })
      })
  }

  backToCredentials = () => {
    this.setState({
      user: null,
      outlet: null,
      outlets: []
    })
  }

  renderCredentialsForm() {
    return (
      <Form onSubmit={this.authenticate}>
        <Form.Input
          label="Tên đăng nhập"
          placeholder="Nhập tên đăng nhập"
          onChange={this.updateField('username')}
        />
        <Form.Input type="password" label="Mật khẩu" onChange={this.updateField('password')} />
        <Button type="submit" content="Tiếp tục" disabled={this.state.updating} />
      </Form>
    )
  }

  renderOutletForm() {
    return (
      <Form onSubmit={this.login}>
        <Header as="h4" content={`Xin chào ${_.get(this.state.user, 'displayName', '')}`} />
        <Form.Select
          label="Cơ sở"
          placeholder="Chọn cơ sở"
          value={this.state.outlet || ''}
          options={this.state.outlets}
          onChange={this.updateField('outlet')}
        />
        <Button type="submit" content="Đăng nhập" disabled={this.state.updating} />
        <Button
          basic
          type="button"
          content="Đổi tài khoản"
          onClick={this.backToCredentials}
          disabled={this.state.updating}
        />
      </Form>
    )
  }

  render() {
    return (
      <Container>
        {this.state.user ? this.renderOutletForm() : this.renderCredentialsForm()}
      </Container>
    )
  }
}

export default withRouter(LoginPage)
